import { closeSnackbar, enqueueSnackbar } from "notistack";
import { IErrorObject } from "../types/api";

export function isApiError(e: unknown): e is IErrorObject {
  return (
    typeof e === "object" &&
    e !== null &&
    "status" in e &&
    "data" in e &&
    typeof e.data === "object" &&
    e.data !== null &&
    "errors" in e.data &&
    "message" in e.data
  );
}

export function showApiError(e: unknown) {
  let message = "Произошла ошибка";

  if (isApiError(e)) {
    const errors = e.data?.errors;
    message = Object.values(errors)
      .map((error) => {
        if (Array.isArray(error)) {
          return error.join("\r\n");
        }

        return error;
      })
      .join("\r\n");
  }
  enqueueSnackbar(message, {
    variant: "error",
    handleClose: closeSnackbar,
  });
}
